export const LINK_REGEX =
  /((http|https):\/\/)?(www\.)?[a-zA-Z0-9-@:%._+~#=]{2,256}\.[a-z]{2,}\b([a-zA-Z0-9-@:%_+.~#?&//=]*)/gi

const getLinksFromText = (text: string) => {
  const matchedLinks = text.match(LINK_REGEX)

  return matchedLinks
}

export default getLinksFromText
